import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_SINGLE_MEDIA_CONTENT,
  FETCH_SINGLE_MEDIA_CONTENT_SUCCESS,
  FETCH_SINGLE_MEDIA_CONTENT_FAILED,
  SINGLE_MEDIA_MESSAGE,
  SINGLE_MEDIA_MESSAGE_SUCCESS,
  SINGLE_MEDIA_MESSAGE_FAILED,
} from "./actionTypes";

export const fetchSingleMedia = (media_id) => (dispatch) => {
  dispatch({
    type: FETCH_SINGLE_MEDIA_CONTENT,
    payload: null,
  });
  http
    .get("single-media/" + media_id)
    .then(({ data }) => {
      dispatch({
        type: FETCH_SINGLE_MEDIA_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_SINGLE_MEDIA_CONTENT_FAILED,
        payload: error,
      });
    });
};

export const postMedia = (formData, media_id) => (dispatch) => {
  let postUrl = "";
  if (media_id != undefined && media_id !== null) {
    postUrl = "edit-media/" + media_id;
  } else {
    postUrl = "add-media";
  }
  dispatch({
    type: SINGLE_MEDIA_MESSAGE,
    payload: null,
  });
  http
    .post(postUrl, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/media");
        }, 2000);
        dispatch({
          type: SINGLE_MEDIA_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: SINGLE_MEDIA_MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: SINGLE_MEDIA_MESSAGE_FAILED,
        payload: error,
      });
    });
};
